<template>
  <div>

    <Stack direction="row">
      <Button @click="this.updateStatistics"
      >Force Update [DO NOT SPAM!]
      </Button>

      <Button @click="showGraphs = !showGraphs">
        {{ showGraphs ? "Hide Graphs" : "Show Graphs" }}
      </Button>
    </Stack>
    <br />

    <template v-if="showGraphs">
      <Card
        as="section"
        background="grey"
        color="background"
        title="Comparison with 2020"
        direction="column"
      >

        <!-- WARNING! Super shitty code coming up here -->
        <!-- This assumes that we started apps on July 10th and continued to get apps everyday until sometime early august  -->

        <TextComponent as="h2">
          Applications
        </TextComponent>
        <Stack direction="row">
          <TextComponent>
            Daily Change
          </TextComponent>
          <apexchart
              style="color: black;"
              width="500"
              type="line"
              :options="{
            xaxis: {
              categories: summaryDates
            }
          }"
              :series="summary.applications.dailyChange"
          />

          <TextComponent>
            Cumulative
          </TextComponent>
          <apexchart
              style="color: black;"
              width="500"
              type="line"
              :options="{
            xaxis: {
              categories: summaryDates
            }
          }"
              :series="summary.applications.cumulative"
          />
        </Stack>


        <TextComponent as="h2">
          Accounts Created
        </TextComponent>
        <Stack direction="row">
          <TextComponent>
            Daily Change
          </TextComponent>
          <apexchart
              style="color: black;"
              width="500"
              type="line"
              :options="{
            xaxis: {
              categories: summaryDates
            }
          }"
              :series="summary.accountsCreated.dailyChange"
          />

          <TextComponent>
            Cumulative
          </TextComponent>
          <apexchart
              style="color: black;"
              width="500"
              type="line"
              :options="{
            xaxis: {
              categories: summaryDates
            }
          }"
              :series="summary.accountsCreated.cumulative"
          />
        </Stack>

        <TextComponent as="h2">
          Application Rate (as % of accounts created)
        </TextComponent>
        <Stack direction="row">

          <TextComponent>
            Daily Rate
          </TextComponent>
          <apexchart
              style="color: black;"
              width="500"
              type="line"
              :options="{
            xaxis: {
              categories: summaryDates
            }
          }"
              :series="[{
                name: '2023',
                data: summary.applicationRate
              }]"
          />

        </Stack>

        <br />


        <img src="https://cdn.hackthe6ix.com/admin_dashboard/crowdmark_banner.webp" style="max-width: 200px">

        <TextComponent as="h2">
          Grade Distribution
        </TextComponent>

        <TextComponent>
          Note: This distribution is based on the personal score, not adjusted team score
        </TextComponent>

        <Stack direction="column">

          <div v-for="category in Object.keys(data.gradeDistribution)" :key="category">
            <TextComponent>
              {{category}}
            </TextComponent>
            <apexchart
                style="color: black;"
                width="500"
                type="bar"
                :options="{
                  xaxis: {
                    categories: Object.keys(data.gradeDistribution[category]).map((x) => parseInt(x)).sort((a, b) => a - b)
                  }
                }"
                :series="[{
                  name: 'Scores',
                  data: Object.keys(data.gradeDistribution[category]).map((x) => parseInt(x)).sort((a, b) => a - b).map(x => data.gradeDistribution[category][x])
                }]"
            />
          </div>

        </Stack>

      </Card>

      <br />

    </template>

    <div :class="[$style.items, $style.items3]">

      <Card
          background="grey"
          color="background"
          direction="column"
          title="System Status"
      >
        <TextComponent color="white">
          Last updated: {{ data.timestamp ? new Date(data.timestamp) : 'N/A' }}
        </TextComponent>

        <TextComponent color="white">
          <b>TOTAL USERS</b>: {{ data.total }}
        </TextComponent>

        <TextComponent v-for="(value, key) in data.groups" color="white" :key="key">
          <b>{{ key.toUpperCase() }}</b>: {{ value }}
        </TextComponent>


      </Card>


      <Card
          background="grey"
          color="background"
          direction="column"
          title="Hacker Status"
      >
        <TextComponent color="white">
          <b># HACKERS</b>: {{ data.groups.hacker }}
        </TextComponent>

        <TextComponent v-for="(value, key) in data.hacker.status" :key="key" v-if="value !== null" color="white">
          <b>{{ key.toUpperCase() }}</b>: {{ value }}
        </TextComponent>
      </Card>


      <Card
          background="grey"
          color="background"
          direction="column"
          title="Submitted Stats"
      >

        <TextComponent as="h3" color="white">
          Gender
        </TextComponent>

        <TextComponent v-for="(value, key) in data.hacker.submittedApplicationStats.gender" :key="key" color="white">
          <b>{{ key.toUpperCase() }}</b>: {{ value }}
        </TextComponent>

        <TextComponent as="h3" color="white">
          RSVP Stats
        </TextComponent>

        <Stack direction="row">
          <TextComponent v-for="(value, key) in data.rsvpStats" :key="key" color="white">
            <b>{{ key.toUpperCase() }}</b>: {{ value }}
          </TextComponent>
        </Stack>
      </Card>


      <Card
          background="grey"
          color="background"
          direction="column"
          title="Application Review"
      >


        <TextComponent as="h3" color="white">
          Summary
        </TextComponent>

        <Stack direction="row">

          <TextComponent color="white">
            <b>REVIEWED</b>: {{ data.hacker.submittedApplicationStats.review.reviewed }} ({{ (100 * data.hacker.submittedApplicationStats.review.reviewed  / data.hacker.status.applied).toFixed(2) }}%)
          </TextComponent>

          <TextComponent color="white">
            <b>NOT REVIEWED</b>: {{ data.hacker.submittedApplicationStats.review.notReviewed }} ({{ (100 * data.hacker.submittedApplicationStats.review.notReviewed  / data.hacker.status.applied).toFixed(2) }}%)
          </TextComponent>

        </Stack>

        <TextComponent as="h3" color="white">
          By Question
        </TextComponent>

        <Stack direction="column">

          <TextComponent color="white" v-for="(value, key) in data.hacker.submittedApplicationStats.review.applicationScores" :key="key">
            <b>{{key.toUpperCase()}}</b>: {{value}} ({{ 100 * (value / data.hacker.status.applied).toFixed(2) }}%)
          </TextComponent>

        </Stack>

      </Card>


      <Card
          background="grey"
          color="background"
          direction="column"
          title="Application Review Leader Board"
      >
        <TextComponent color="white" v-for="(reviewer, index) in reviewers" :key="index">
          <b># {{index + 1}}. {{ reviewer.name }}</b>: {{ reviewer.total }}
        </TextComponent>
      </Card>

      <Card
          background="grey"
          color="background"
          direction="column"
          title="Question Response Rate"
      >
        <TextComponent color="white" v-for="(question, index) in questions" :key="index">
          <b>{{index + 1}}. {{ question.name }}</b>: {{ question.total }} ({{ (100 * question.total / data.groups.hacker).toFixed(2) }}%)
        </TextComponent>

      </Card>
    </div>

    <br />

    <Button @click="showJSONDump = !showJSONDump">
      {{ showJSONDump ? "Hide JSON Dump" : "Show JSON Dump" }}
    </Button>
    <Card background="grey" v-if="showJSONDump">
      <vue-json-pretty :data="data" :path="'res'"></vue-json-pretty>
    </Card>

  </div>
</template>

<script>
  import Button from '@hackthe6ix/vue-ui/Button';
  import Stack from '@hackthe6ix/vue-ui/Stack';
  import TextComponent from '@hackthe6ix/vue-ui/Text';
  import swal from 'sweetalert';
  import VueJsonPretty from 'vue-json-pretty';
  import 'vue-json-pretty/lib/styles.css';
  import Card from '../../../containers/Card';
  import { getStatistics } from '../../../utils/api';

  export default {
  name: 'ApplicantStats',
  components: {
    VueJsonPretty,
    TextComponent,
    Stack,
    Button,
    Card
  },
  data() {
    return {
      data: {
        groups: {},
        hacker: {
          status: {},
          submittedApplicationStats: {
            review: {}
          }
        }
      },

      showJSONDump: false,
      showGraphs: false,

      // Yes please don't judge me for hardcoding this stuff
      previousApplicationStatistics: {
        '07-09': {'cumulative': 1, 'dailyChange': 1},
        '07-10': {'cumulative': 39, 'dailyChange': 38},
        '07-11': {'cumulative': 71, 'dailyChange': 32},
        '07-12': {'cumulative': 95, 'dailyChange': 24},
        '07-13': {'cumulative': 121, 'dailyChange': 26},
        '07-14': {'cumulative': 139, 'dailyChange': 18},
        '07-15': {'cumulative': 160, 'dailyChange': 21},
        '07-16': {'cumulative': 182, 'dailyChange': 22},
        '07-17': {'cumulative': 205, 'dailyChange': 23},
        '07-18': {'cumulative': 231, 'dailyChange': 26},
        '07-19': {'cumulative': 281, 'dailyChange': 50},
        '07-20': {'cumulative': 329, 'dailyChange': 48},
        '07-21': {'cumulative': 400, 'dailyChange': 71},
        '07-22': {'cumulative': 476, 'dailyChange': 76},
        '07-23': {'cumulative': 642, 'dailyChange': 166},
        '07-24': {'cumulative': 926, 'dailyChange': 284},
        '07-25': {'cumulative': 1096, 'dailyChange': 170},
        '07-26': {'cumulative': 1126, 'dailyChange': 30},
        '07-27': {'cumulative': 1184, 'dailyChange': 58},
        '07-28': {'cumulative': 1234, 'dailyChange': 50},
        '07-29': {'cumulative': 1281, 'dailyChange': 47},
        '07-30': {'cumulative': 1363, 'dailyChange': 82},
        '07-31': {'cumulative': 1504, 'dailyChange': 141},
        '08-01': {'cumulative': 1654, 'dailyChange': 150},
        '08-04': {'cumulative': 1655, 'dailyChange': 1}
      }
    };
  },
  computed: {
    questions() {

      let rawQuestions;

      try {
        rawQuestions = this.data.hacker.questionBreakdown || {};
      } catch (e) {
        rawQuestions = {};
      }

      return Object.keys(rawQuestions).map(questionID => ({
        total: rawQuestions[questionID],
        name: questionID.toUpperCase()
      })).sort((a, b) => {
        if (a.total < b.total) {
          return 1
        } else if (a.total > b.total) {
          return -1
        } else {
          return 0
        }
      });
    },
    reviewers() {
      let rawReviewers;

      try {
        rawReviewers = this.data.hacker.submittedApplicationStats.review.reviewers || {};
      } catch (e) {
        rawReviewers = {};
      }

      return Object.keys(rawReviewers).map(reviewerID => rawReviewers[reviewerID]).sort((a, b) => {
        if (a.total < b.total) {
          return 1
        } else if (a.total > b.total) {
          return -1
        } else {
          return 0
        }
      });
    },
    summaryDates() {
      const dates = [];

      for (const date in this.previousApplicationStatistics) {
        if (dates.indexOf(date) === -1) {
          dates.push(date);
        }
      }
      for (const date in this.data.summary) {
        if (dates.indexOf(date) === -1) {
          dates.push(date);
        }
      }

      return dates.sort();
    },
    summary() {
      const out = {
        accountsCreated: {
          cumulative: [],
          dailyChange: []
        },
        applications: {
          cumulative: [],
          dailyChange: []
        },
        applicationRate: []
      };

      // -------------------------------------------------
      // Add the current statistics
      const cumulativeApplications = [];
      const dailyChangeApplications = [];

      for (const date of this.summaryDates) {
        if (this.data.summary && this.data.summary[date] && this.data.summary[date].submitted) {

          cumulativeApplications.push(this.data.summary[date]['submitted']['cumulative']);
          dailyChangeApplications.push(this.data.summary[date]['submitted']['dailyChange']);
        } else {
          cumulativeApplications.push(0);
          dailyChangeApplications.push(0);
        }
      }
      out.applications.cumulative.push({
        name: '2023',
        data: cumulativeApplications
      });
      out.applications.dailyChange.push({
        name: '2023',
        data: dailyChangeApplications
      });


      const cumulativeAccountCreation = [];
      const dailyChangeAccountCreation = [];

      for (const date of this.summaryDates) {
        if (this.data.summary && this.data.summary[date] && this.data.summary[date].created) {

          cumulativeAccountCreation.push(this.data.summary[date]['created']['cumulative']);
          dailyChangeAccountCreation.push(this.data.summary[date]['created']['dailyChange']);
        } else {
          cumulativeAccountCreation.push(0);
          dailyChangeAccountCreation.push(0);
        }
      }
      out.accountsCreated.cumulative.push({
        name: '2023',
        data: cumulativeAccountCreation
      });
      out.accountsCreated.dailyChange.push({
        name: '2023',
        data: dailyChangeAccountCreation
      });

      // Application rate
      for (let i = 0; i < this.summaryDates.length; i++) {
        if (cumulativeAccountCreation[i]) {
          out.applicationRate.push(100 * (cumulativeApplications[i] / cumulativeAccountCreation[i]));
        } else {
          out.applicationRate.push(0);
        }
      }

      // -------------------------------------------------
      // Add last year's application statistics
      // bro wtf is going on here
      const cumulative2020 = [];
      const dailyChange2020 = [];

      for (const date of this.summaryDates) {
        if (this.previousApplicationStatistics[date]) {
          cumulative2020.push(this.previousApplicationStatistics[date]['cumulative']);
          dailyChange2020.push(this.previousApplicationStatistics[date]['dailyChange']);
        } else {
          cumulative2020.push(0);
          dailyChange2020.push(0);
        }
      }
      out.applications.cumulative.push({
        name: '2020',
        data: cumulative2020
      });
      out.applications.dailyChange.push({
        name: '2020',
        data: dailyChange2020
      });

      return out;

    }
  },
  beforeMount() {
    this.loadStatistics();
  },
  methods: {
    updateStatistics() {
      swal({
        title: 'CONFIRM ACTION',
        text: 'Are you sure you want to refresh statistics? This is a computational intensive action that may result in severe server stress.',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then((confirm) => {
        if (confirm) {
          this.loadStatistics(true);
        }
      });
    },
    loadStatistics(update) {
      getStatistics(update).then((data) => {
        this.data = data.data;
      });
    },
  },
};
</script>
<style src="./Stats.module.scss" lang="scss" module />
